<template>
  <svg
    width="100"
    height="100"
    viewBox="-50 -50 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="bot"
    :class="{ 'is-mobile': isPortrait }"
  >
    <circle
      class="circle sub-circle first"
      cx="14.8164"
      cy="34.0202"
      r="6.85714"
      fill="#FFffff"
    />
    <circle
      class="circle sub-circle second"
      cx="28.5306"
      cy="23.5713"
      r="3.59184"
      fill="#FFffff"
    />
    <circle
      class="circle main third"
      cx="16.449"
      cy="13.449"
      r="10.449"
      fill="#ffffff"
    />
    <circle
      class="circle sub-circle fourth"
      cx="34.4082"
      cy="29.4488"
      r="3.59184"
      fill="#ffffff"
    />
  </svg>
</template>

<script setup>
//variables
const iterationCount = ref(0);
const currentAnimation = ref(null);
const isPortrait = inject("isPortrait");
const { $gsap, $motionPathPlugin } = useNuxtApp();

// Only register plugin on client side
if (process.client && $gsap) {
  $gsap.registerPlugin($motionPathPlugin);
}

onMounted(() => {
  startAnimation();
});
onUnmounted(() => {
  killAnimations();
});
function startAnimation() {
  killAnimations();
  iterationCount.value = 0;
  $gsap.set(".circle", {
    clearProps: "all",
  });
  initialPos();
  nextTick(() => {
    loader();
  });
}
function killAnimations() {
  if (currentAnimation.value) {
    currentAnimation.value.kill();
  }
  $gsap.killTweensOf(".circle");
}
function loader() {
  killAnimations();
  const tl = $gsap.timeline({
    onComplete: () => {
      iterationCount.value = 0;
      resetAnimation();
    },
    onRepeat: () => {
      iterationCount.value++;
      if (iterationCount.value % 10 === 0) {
        resetAnimation();
      }
    },
  });

  currentAnimation.value = tl.fromTo(
    ".circle",
    {
      autoAlpha: 0.1,
      scale: 0.1,
      x: 0,
      y: 0,
      transformOrigin: "center center",
    },
    {
      duration: 0.8,
      autoAlpha: 1,
      scale: 1,
      motionPath: {
        path: [
          { x: 10, y: 40 },
          { x: 5, y: -40 },
          { x: -25, y: 10 },
          { x: 0, y: 0 },
        ],
        type: "soft",
        curviness: 1,
      },
      stagger: {
        each: 0.1,
        from: "start",
      },
      repeat: -1,
      yoyo: true,
      repeatDelay: 0.4,
      ease: "power2.inOut",
    },
  );
}
function resetAnimation() {
  killAnimations();
  initialPos();
  nextTick(() => {
    loader();
  });
}
function talking() {
  killAnimations();
  initialPos2();
  currentAnimation.value = $gsap.fromTo(
    ".circle",
    {
      attr: {
        cy: 20,
        r: 2,
      },
    },
    {
      duration: 0.4,
      attr: {
        cy: 15,
        r: 4,
      },
      stagger: 0.2,
      repeat: -1,
      yoyo: true,
      ease: "power1.inOut",
    },
  );
}
function initialPos() {
  $gsap.set([".first", ".second", ".third", ".fourth"], {
    attr: {
      cx: $gsap.utils.wrap([14.8164, 28.5306, 16.449, 34.4082]),
      cy: $gsap.utils.wrap([34.0202, 23.5713, 13.449, 29.4488]),
      r: $gsap.utils.wrap([6.85714, 3.59184, 10.449, 3.59184]),
    },
  });
}
function initialPos2() {
  $gsap.set([".first", ".second", ".third", ".fourth"], {
    attr: {
      cx: $gsap.utils.wrap([35, 15, 5, 25]),
      cy: 22,
      r: 3,
    },
  });
}
</script>

<style lang="scss" scoped>
svg {
  position: absolute;
  left: -26px;
  top: -10px;
  height: 36px;
  width: 36px;
  pointer-events: none;
  will-change: transform;
  @include mq(landscape-1) {
    width: 30px;
    height: 30px;
    left: -18px;
    top: -6px;
  }

  .circle {
    will-change: transform, opacity;
    transform-origin: center center;
  }

  &.is-mobile {
    width: 30px;
    height: 30px;
    left: -18px;
    top: -6px;
  }
}
</style>
